export default __webpack_public_path__ + "static/media/ic_truck_block.57e13015.svg";